import { Dimension, Valence } from '@upright/common/model/types';
import { useNetImpactLensContext } from '@upright/ui/common/upright/core/impact-lenses/net-impact/common/use-net-impact-lens-context';
import { DimensionBarDataLabel } from '@upright/ui/common/upright/core/impact-lenses/net-impact/data-area/dimension-bar-data-label';
import { DimensionBar } from '@upright/ui/common/upright/core/impact-lenses/net-impact/data-area/dimension-bar/dimension-bar';
import { CSSTransition } from 'react-transition-group';

interface Props {
  dimension: Dimension;
  valence: Valence;
  in?: boolean;
}

export function DimensionBarAndLabel(props: Props) {
  const ctx = useNetImpactLensContext();
  if (ctx === undefined || !ctx.state.showDimensionBars) {
    // TODO: Instead of this, display bar with empty length
    return <></>;
  }
  return (
    <CSSTransition
      timeout={500}
      key={`${props.dimension}+${props.valence}+DimensionBar`}
      classNames={'dimensionBar'}
      unmountOnExit={true}
      in={props.in}
    >
      <g>
        <DimensionBar dimension={props.dimension} valence={props.valence} />
        <DimensionBarDataLabel dimension={props.dimension} valence={props.valence} />
      </g>
    </CSSTransition>
  );
}
